import type { CardConfig } from '../models/card-model';
import { CardType } from '../models/card-model';
import { parseChartPresentationInput } from './parse-chart-presentation-input.util';

function isChartLikeCard(cardType: unknown): boolean {
	return cardType === CardType.Chart || cardType === 'chart';
}

/**
 * In-place: GraphQL `getCard` may return `presentation` as AWSJSON;
 * editor/runtime expect a parsed object.
 */
export function applyChartPresentationWireFromApi(
	cfg: Partial<CardConfig> & Record<string, unknown>
): void {
	if (!isChartLikeCard(cfg.cardType)) {
		return;
	}
	if (cfg.presentation == null) {
		return;
	}
	if (
		typeof cfg.presentation === 'object' &&
		!Array.isArray(cfg.presentation)
	) {
		return;
	}
	cfg.presentation = parseChartPresentationInput(cfg.presentation);
}
